module.exports = __webpack_public_path__ + "static/media/2.f70c0ba7.jpeg";